'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extend = require('@souche-f2e/extend');

var _extend2 = _interopRequireDefault(_extend);

var _utils = require('./utils');

var _utils2 = _interopRequireDefault(_utils);

var _api = require('./api');

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;

var userTag = '';
var isGetUserTag = false;

// 常量类文件
var Const = {
    /**
     * sessionStorage 的key 
     */
    // SPM key
    SESSION_SPM: 'spm',
    /**
     * cookie 的key 
     */
    // 打开页面的spm值，存储一天
    COOKIE_SPM: 'nspm', // 新的spm值，避免跟服务器冲突
    COOKIE_SPM2: 'spm',
    // 给app用的spm值，缓存90天
    COOKIE_SPM_APP_USE: 'spm-app-use'
};

// 获取用户token
var getUserTag = function getUserTag() {
    if (userTag) {
        return Promise.resolve(userTag);
    }
    if (isGetUserTag) {
        return isGetUserTag;
    }
    isGetUserTag = _api2.default.DataPlatform.getUserTag({
        isSaveCookie: 1
    }).then(function (data) {
        isGetUserTag = false;
        userTag = data.usertag;
        _utils2.default.configData.getUserTag && _utils2.default.configData.getUserTag(userTag);
        return userTag;
    }).catch(function () {
        isGetUserTag = false;
        userTag = 'error';
        _utils2.default.configData.getUserTag && _utils2.default.configData.getUserTag(userTag);
    });
    return isGetUserTag;
};

// 处理页面动态隐藏显示
// 文档地址： http://doc.souche-inc.com/pages/viewpage.action?pageId=6033211
var dealSpmDom = function dealSpmDom(spm) {
    _api2.default.finance.queryHideDisplayMessageBySpm({
        spm: spm
    }).then(function (res) {
        _utils2.default.configData.success(res);
    });
};

// spm 统计分析
// 文档地址： http://doc.souche-inc.com/pages/viewpage.action?pageId=6033211
var setSpmData = function setSpmData() {
    var params = _utils2.default.configData;
    if (params.spm) {
        _utils2.default.setCookie(Const.COOKIE_SPM, params.spm, 1);
        _utils2.default.setCookie(Const.COOKIE_SPM2, params.spm, 1);
        // 动态隐藏显示区域使用
        _utils2.default.setItem(Const.SESSION_SPM, params.spm);
        _api2.default.DataPlatform.advertisement({
            spm: params.spm,
            source: params.source
        }).then(function (res) {
            if (res.spm) {
                _utils2.default.setCookie(Const.COOKIE_SPM_APP_USE, (0, _stringify2.default)(res), 90);
                _utils2.default.configData.uploadPosition && _utils2.default.configData.uploadPosition();
            }
        });
    }
    var spm = _utils2.default.getItem(Const.SESSION_SPM);
    spm && _utils2.default.configData.success && dealSpmDom(spm);
};

exports.default = {
    init: function init() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        // 如果是服务端渲染，则不走统计的逻辑
        if (params.isServer) {
            return;
        }
        _utils2.default.configData = (0, _extend2.default)(_utils2.default.getDefaultParams, params);
        getUserTag();
        setSpmData();
    },
    uploadPosition: function uploadPosition() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var appSpmData = _utils2.default.getCookie(Const.COOKIE_SPM_APP_USE);
        try {
            appSpmData = JSON.parse(appSpmData);
        } catch (e) {
            console.error('spm 数据异常'); // eslint-disable-line
            return;
        }
        var positionData = (0, _extend2.default)({}, {
            lon: data.longitude || '0.0',
            lat: data.latitude || '0.0'
        }, appSpmData);
        _api2.default.DataPlatform.latAndLonUpload(positionData);
    },

    // 种cookie功能
    data2Cookie: function data2Cookie(data) {
        _api2.default.DataPlatform.addUserInfo2Cookie(data);
    },

    // 即时
    getCookieSpm: function getCookieSpm() {
        return _utils2.default.getCookie(Const.COOKIE_SPM);
    },

    // 即时
    getUrlSpm: function getUrlSpm() {
        return _utils2.default.configData.spm;
    },
    getSpmUrl: function getSpmUrl(url) {
        var spm = _utils2.default.getCookie(Const.COOKIE_SPM) || '';
        if (url.indexOf('?') > -1) {
            var params = _utils2.default.getParams(url);
            if (params.spm) {
                return url;
            }
            return url + '&spm=' + spm;
        }
        if (spm) {
            return url + '?spm=' + spm;
        }
        return url;
    },
    uploadLogin: function uploadLogin(token) {
        return _api2.default.leaseconsumer.userInfoUpload({
            userTag: userTag,
            token: token
        });
    },

    // Promise 流，动态获取userTag
    getUserTag: getUserTag
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/souche-spm/dist/index.js
// module id = uUWT
// module chunks = 8